import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import MiniLoader from "../../UI/MiniLoader";
import { scrollToTop } from "../../../JS/scrollToTop";
import { capitalize } from "./Gha_ProfileInfo";
import { inAppBrowser } from "../../JS/inAppBrowser";





const Gha_SelectAccount = (props) => {

    



     

    const { t } = props;

    const handleClickNext=(profile)=>{
        props.handleSelectProfileFromSelectAccount(profile);
           
    }

    const openLinkHandler = (link, displayName) => {

        if (link) {
            inAppBrowser(link, {...props,menuColor:{assetFontColor:"#000000",backgroundColor:"#D0D2D7"}}, false, {displayName: displayName, dontSetCurrentWidget: true, targetUrl:link})
        }

    }
    
    const getProfileImage = (color) => {
        let path;
        console.log("colr", color)
        switch (color) {
            case 'SILVER':
                path = require("./assests/avatar-silver.png");
                break;
            case 'GOLD':
                path = require("./assests/avatar-gold.png");
                break;
            case 'PLATINUM':
                path = require("./assests/avatar-platinum.png");
                break;
            case 'TITANIUM':
                path = require("./assests/avatar-titanium.png");
                break;
        }
        console.log("unexpected color:", color)
        return path;
    }


   



    useEffect(() => {
        console.log("inside select Acct")
        console.log("all profilesData", props.allProfilesData)
        scrollToTop();
        if(props.allProfilesData&& props.allProfilesData.length==1){
            handleClickNext(props.allProfilesData[0])
        }

        
    }, []);




    return (
        <>
             
                <header class="inner-pages w-footer subpages">
                <a class="button-back" onClick={props.handleBack}></a>
                    <div class="heading align-center">
                        <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />                            </div>
                    </div>
                <div class="logout" onClick={props.handleLogoutUser}>
                    {t("gha.logout")}
                </div>
                </header>

            {props.allProfilesData && props.allProfilesData.length>1 &&
            
            <>
                <section class="widgets">
                    <div class="widget-header">
                        <div class="widget-header-title">{t("gha.select_account_heading")}</div>
                        <div class="widget-header-subtitle">{t("gha.select_account_subheading")}
                             </div>
                    </div>
                    <div id="GHALogin" class="widgets sign-up">
                        <div class="row user-list">
                            {
                                props.allProfilesData.map(profile=>{
                                      
                                   return <div class="tile-selection tile-container" onClick={()=>{handleClickNext(profile)}}>
                                        <div class="tile-selection-img">
                                           <img src={getProfileImage(profile.membershipColor)} />
                                        </div>
                                        <div class="tile-selection-text">
                                            <div class="tile-selection-heading">{(profile.firstName || '') + (profile.lastName || '')}</div>
                                           {/* <div class="tile-selection-desc-membershipLevel">{capitalize( profile.membershipColor)}</div> */}
                                            <div class="tile-selection-desc">{(profile.membershipNumber)}</div>
                                        </div>
                                    </div>
                                })
                            }
                         
                            
                        </div>
                    </div>
                    
                    <div id="GHAAccount" class="widgets sign-up spa-listing"> 
                    <div class="row access-details">
                                <div class="form-control gha-delete-account">
                                    <button class="primary w-100 margin-bottom-1"  onClick={()=>{openLinkHandler(props.requiredLinks.deleteAccountLink,"Delete Gha Account")}} >
                                      
                                            <span style={{color:"white"}}> {t("gha.delete_account")} </span></button>
                                </div>
                            </div>
                    </div>
                </section>

            </>
            }
                

        </>

    );
};

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
    };
};

export default connect(mapStateToProps, { setGoHome,  closeOrderPopUp, sendAnalytics })(
    withTranslation("translations")(Gha_SelectAccount)
);